
import api from '../interceptors/interceptor';
import { API_ROUTES } from '../constants/apiRoutes';

export class DeploymentInstanceRepository {
  private static instance: DeploymentInstanceRepository;

  /**
   * Singleton pattern - ensure only one instance exists
   */
  public static getInstance(): DeploymentInstanceRepository {
    if (!DeploymentInstanceRepository.instance) {
      DeploymentInstanceRepository.instance = new DeploymentInstanceRepository();
    }
    return DeploymentInstanceRepository.instance;
  }

  /**
   * Get all models
   */
  public async getDeploymentInstances(): Promise<any> {
    return (await api.get(API_ROUTES.DEPLOYMENT_INSTANCES))?.data;
  }

  public async getDeploymentInstanceById(id: string): Promise<any> {
    return (await api.get(API_ROUTES.DEPLOYMENT_INSTANCES_ID(id)))?.data;
  }

  public async deleteDeploymentInstanceById(id: string, model_name: string): Promise<any> {
    return (await api.delete(API_ROUTES.DEPLOYMENTS_DELETE(id, model_name)))?.data;
  }

  public async deploymentInstance(id: string): Promise<any> {
    return (await api.post(API_ROUTES.DEPLOYMENTS_DEPLOY_INSTANCE(id)))?.data;
  }

  public async startInstance(id: string): Promise<any> {
    return (await api.post(API_ROUTES.DEPLOYMENTS_SCALE_INSTANCE(id)))?.data;
  }

  public async stopInstance(id: string): Promise<any> {
    return (await api.post(API_ROUTES.DEPLOYMENTS_STOP_INSTANCE(id)))?.data;
  }

  public async restartInstance(id: string): Promise<any> {
    return (await api.post(API_ROUTES.DEPLOYMENTS_RESTART_INSTANCE(id)))?.data;
  }

  public async deploymentInstancesConfigsById(id: string): Promise<any> {
    return (await api.get(API_ROUTES.DEPLOYMENT_INSTANCES_CONFIGS(id)))?.data;
  }

}
